<app-page-layout
    headerNavigation="none"
    [bgColor]="theme().pageBackgroundColor"
    [gradientDirection]="theme().pageBackgroundGradientDirection">
    <ng-container pageBackground>
        @if (theme().backgroundPatternIconUrl; as backgroundPatternIconUrl) {
            <app-banner-pattern
                [iconUrl]="backgroundPatternIconUrl"
                [rotationDegrees]="theme().backgroundPatternRotationDegrees"
                [opacity]="theme().backgroundPatternOpacity"
                [rowColor]="theme().backgroundPatternRowColor"
                [tileSizeRem]="theme().backgroundPatternTileSizeRem"
                [rowStrideRem]="theme().backgroundPatternRowStrideRem"
                [minimumRowSpacingRem]="theme().backgroundPatternMinimumRowSpacingRem"
                [showAnimation]="backgroundAnimationEnabled()"></app-banner-pattern>
        }
    </ng-container>

    <div class="flex min-h-full flex-col items-center justify-center gap-8 overflow-x-clip px-7 pb-[18vh] pt-10">
        <div class="party-game-splash-screen__heading mx-auto flex w-fit min-w-0 items-end gap-2">
            <div
                class="min-w-0 max-w-full flex-shrink break-words text-center text-[clamp(4rem,18vw,8.25rem)] leading-none [overflow-wrap:anywhere]"
                [dcColor]="theme().titleColor"
                dcTypography="bulevar-132">
                {{ title() }}
            </div>

            @if (badgeIcon(); as badgeIcon) {
                <app-icon-badge class="flex-none py-2" [sizeRem]="2.25">
                    <dc-icon badge-icon [icon]="badgeIcon"></dc-icon>
                </app-icon-badge>
            }
        </div>

        <div class="w-full empty:hidden">
            <ng-content></ng-content>
        </div>
    </div>
</app-page-layout>
